export enum AuthUIState {
  SignIn,
  SignedIn,
  ForceNewPassword,
  ResetPassword,
  ResetPasswordConfirm,
}

export interface AuthUIData {
  state: AuthUIState;
  data?: StateData;
}

export interface StateData {
  forceNewPasswordUser?: any;
  email?: string;
  errorMessage?: string;
}
